import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=f3c4eb3e&scoped=true"
import script from "./PurchaseCard.vue?vue&type=script&lang=js"
export * from "./PurchaseCard.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCard.vue?vue&type=style&index=0&id=f3c4eb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4eb3e",
  null
  
)

export default component.exports